import { requst } from '../config'

// 日历上数据
export const getWeatherCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/weather/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getWeatherDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getWeatherByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/weather/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getWeatherByIdApi = id => {
    const url = `/monitor/weather/${id}`
    return requst.get(url)
}

// 获取 Observations 数据
export const getObservationsDataApi = id => {
    const url = `/monitor/weather/observation/list?weatherId=${id}`
    return requst.get(url)
}

// 提交 Weather 总结
export const postWeatherCommentApi = commentData => {
    const url = `/monitor/weather`
    return requst.post(url, { ...commentData })
}

// 修改 Weather 总结
export const putWeatherCommentApi = (commentData, id) => {
    const url = `/monitor/weather`
    return requst.put(url, { ...commentData, id })
}

// 提交 Observations 数据
export const postObservationsDataApi = (observationsParams, id) => {
    const url = `/monitor/weather/observation/addOrUpdateBatch/${id}`
    return requst.post(url, observationsParams)
}
